module.exports = __webpack_public_path__ + "img/east_african_federation.65f4af67.svg";